import {Templates} from './Templates.js';
import {SAFire} from './safire.js';

export class SACodeDisplay extends HTMLElement {
	static observedAttributes = [`code`];
	constructor() {
		super();
		[this.el, this.$] = Templates(`SACodeDisplay`);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {
		if (this.hasAttribute("listen")) {
			document.getElementById(this.getAttribute(`listen`)).addEventListener('safire-sacode-click', evt=>this.detailsEvent(evt));
		}
		this.dispatchEvent(new CustomEvent(`safire-sacode-display-connected`, { mode: `open`, detail: this }));

		const namespace = this.getAttribute(`namespace`)?.trim();
		const version = this.getAttribute(`version`)?.trim();
		const code = this.getAttribute(`code`)?.trim();
		if (namespace==this.namespace && version==this.version && code==this.code) return;
		if (this.call_in_progress) {
			this.call_in_progress.abort();
			this.call_in_progress = null;
		}
		if (``==code) {	// clear the display
			this.code = ``;
			// @TODO Clear the display
			return;
		}
		this.version = version;
		this.namespace = namespace;
		this.code = code;
		this.classList.add(`loading`);
		this.call_in_progress = new AbortController();
		SAFire.API().SACode(version, namespace, code, { signal: this.call_in_progress.signal }).then(
			js => {
				// note we use this. and our captured vars to do this test, not vars returned from the server
				if (this.namespace != namespace
					|| this.version != version
					|| this.code != code) {
					// should never happen because of call_in_progress
					return;	// another request started while we were loading, we just drop ourselves
				}
			}
		).finally( ()=>{
			this.classList.remove(`loading`);
			this.call_in_progress = null;
		});
	}
	setVNA(version, namespace, code) {
		this.version = version;
		this.namespace = namespace;
		this.code = code;
		this.setAttribute(`version`, version);
		this.setAttribute(`namespace`, namespace);
		this.setAttribute(`code`, code);
	}
	setSACode(sacode) {
		if (sacode===null) {
			// clear
			this.setVNA(null,null,null);
			this.$.parts.innerText=``;
			return;
		}
		this.setVNA(sacode.version?.trim(), sacode.namespace?.trim(), sacode.code?.trim());
		this.$.parts.innerText = ``;
		sacode.fullname_parts.forEach( p => {
			const div = document.createElement(`div`);
			div.innerText = p;
			this.$.parts.appendChild(div);
		});
	}
	attributeChangedCallback(attrib, oldValue, newValue) {
		// console.log(`attributeChangedCallbale ${attrib} = ${newValue}`);
	}
	detailsEvent(evt) {
		// console.log(`SACodeDisplay, detail = `, evt.detail);
		this.setSACode(evt.detail.sacode);
	}
}
customElements.define(`safire-sacode-display`, SACodeDisplay);